export default {
      id: "oc-bank-card-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-bank-card",
      toString: function () {
        return this.url;
      }
    }